import { apiFetch } from '../../config/api';

/**
 * Navigation Service
 * Handles navigation-related API operations
 */
export const navigationService = {
  /**
   * Load tenant navigation
   */
  async loadTenantNavigation() {
    const response = await apiFetch(`/api/v1/tenant/navigation`);
    return response.navigation || [];
  },

  /**
   * Update tenant navigation
   */
  async updateTenantNavigation(navigation) {
    const response = await apiFetch(`/api/v1/tenant/navigation`, {
      method: 'PUT',
      body: JSON.stringify(navigation),
    });
    return response.data;
  },
};
